export default __webpack_public_path__ + "static/media/raro-ajuda.b2e5e336.webp";